import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Pimprichichwadtomumbaicab() {



  const cardData =
  {
    keyword: 'Pimpri Chinchwad to Mumbai Cab',
    heading: 'Sai Trupti Cabs: Pimpri Chinchwad to Mumbai Cab',
    headingDescription: 'Sai Trupti Cabs provides safe and comfortable Pimpri Chinchwad to Mumbai cab services, ensuring a smooth and worry-free journey for every passenger. Our fleet of well-maintained Sedan, SUV, and Luxury vehicles is equipped with AC, spacious seating, and clean interiors for a pleasant travel experience. Whether you’re heading to Mumbai city, Navi Mumbai, or Mumbai Airport, our professional, background-verified chauffeurs ensure on-time pickup, courteous service, and complete safety throughout the trip. With transparent pricing, flexible one-way and round-trip options, and 24×7 customer support, Sai Trupti Cabs makes intercity travel convenient and affordable. Enjoy a seamless ride from Pimpri Chinchwad to Mumbai with Sai Trupti Cabs — your trusted partner for reliable outstation taxi services.',

    top: 'Top Places to Visit in Mumbai with Sai Trupti Cabs',

"topPlaces": [
  {
    "title": "Gateway of India",
    "description": "The Gateway of India stands as Mumbai’s most iconic landmark, overlooking the Arabian Sea in majestic grandeur. Built in 1924 to commemorate King George V’s visit, it blends Indo-Saracenic architecture with colonial elegance. Tourists flock here to enjoy ferry rides to Elephanta Island and admire the sun setting behind the monument. Surrounded by historic hotels and lively street vendors, it is the perfect starting point for exploring South Mumbai’s heritage charm."
  },
  {
    "title": "Marine Drive",
    "description": "Marine Drive, famously known as the Queen’s Necklace, is a 3.6 km boulevard curving gracefully along the Arabian Sea. At night, its glittering streetlights resemble a necklace of pearls, enchanting both locals and travelers. The promenade is perfect for evening strolls, jogs, or simply sitting by the sea breeze. Watching the sunset here with the skyline of Mumbai shimmering in the background offers one of the most serene moments in the bustling metropolis."
  },
  {
    "title": "Chhatrapati Shivaji Maharaj Terminus (CSMT)",
    "description": "A UNESCO World Heritage Site, Chhatrapati Shivaji Maharaj Terminus is a masterpiece of Victorian Gothic architecture fused with Indian artistry. Built in 1887, this grand railway station pulsates with Mumbai’s heartbeat as thousands commute daily. The ornate domes, pointed arches, and stained glass windows narrate stories of the city’s colonial past. It remains not just a transport hub but an architectural marvel symbolizing Mumbai’s vibrant spirit."
  },
  {
    "title": "Elephanta Caves",
    "description": "Situated on Elephanta Island, about 10 km from Mumbai’s shore, the Elephanta Caves are a UNESCO-listed heritage site dating back to the 5th century. These rock-cut temples are dedicated to Lord Shiva and feature magnificent sculptures, including the colossal Trimurti idol. Accessible by ferry from the Gateway of India, the island offers a mix of history, spirituality, and scenic charm. Visitors are captivated by its ancient artistry and tranquil surroundings."
  },
  {
    "title": "Juhu Beach",
    "description": "Juhu Beach is one of Mumbai’s most beloved seaside destinations, stretching over six kilometers along the Arabian coast. Locals and tourists gather here to relish iconic street foods like pav bhaji, bhel puri, and gola. The evenings come alive with laughter, vendors, and the sound of crashing waves. Watching planes land nearby at sunset makes this beach a truly cinematic Mumbai experience. It’s where relaxation meets the vibrant pulse of city life."
  },
  {
    "title": "Haji Ali Dargah",
    "description": "Haji Ali Dargah stands gracefully on a tiny islet off Worli, connected to the mainland by a narrow causeway. Built in the 15th century, it houses the tomb of the revered Sufi saint Pir Haji Ali Shah Bukhari. The white marble structure surrounded by the sea exudes spiritual peace and architectural beauty. At high tide, the path gets submerged, making the shrine appear to float on water—a breathtaking symbol of faith amidst Mumbai’s urban energy."
  },
  {
    "title": "Sanjay Gandhi National Park",
    "description": "Spread across 100 square kilometers, Sanjay Gandhi National Park is a lush green oasis within the city limits of Mumbai. It offers nature trails, waterfalls, boating, and even a mini zoo for families. The ancient Kanheri Caves nestled inside the park showcase Buddhist rock-cut architecture dating back over 2,000 years. A favorite weekend escape for Mumbaikars, the park perfectly balances nature, history, and adventure in one breathtaking expanse."
  },
  {
    "title": "Siddhivinayak Temple",
    "description": "The Shree Siddhivinayak Temple in Prabhadevi is one of Mumbai’s most revered spiritual landmarks dedicated to Lord Ganesha. Built in 1801, it attracts devotees from across India, including film stars and politicians. The temple’s golden dome and intricately carved idol radiate divine grace. Devotees believe that praying here fulfills wishes, making it a hub of faith, devotion, and cultural unity in the heart of Mumbai."
  },
  {
    "title": "Colaba Causeway Market",
    "description": "Colaba Causeway is Mumbai’s vibrant shopping street known for its eclectic mix of fashion, handicrafts, antiques, and cafés. Whether you’re hunting for souvenirs, jewelry, or bohemian clothing, this market offers it all at irresistible prices. The charming colonial architecture adds to its nostalgic charm. With nearby attractions like the Gateway of India and Leopold Café, Colaba represents the city’s cosmopolitan soul and artistic flair."
  },
  {
    "title": "Bandra-Worli Sea Link",
    "description": "The Bandra-Worli Sea Link is a marvel of modern engineering connecting South Mumbai with the western suburbs. Its cable-stayed structure gleams over the Arabian Sea, especially when illuminated at night. Driving across this eight-lane bridge offers panoramic skyline views and a glimpse of Mumbai’s futuristic spirit. The Sea Link is not just a roadway but a symbol of progress, resilience, and Mumbai’s forward-moving ambition."
  }
],



"services": [
  {
    "name": "Pimpri Chinchwad to Mumbai Cab",
    "description": "Pimpri Chinchwad to Mumbai Cab offers reliable intercity cab services for travelers commuting between PCMC and Mumbai. The service features well-maintained vehicles, professional drivers, and on-time pickups. Ideal for business trips, family travel, and airport transfers, this cab service ensures safety, comfort, and hassle-free journeys. With transparent pricing and flexible booking options, passengers can enjoy a smooth and convenient ride across the Pune-Mumbai route."
  },
  {
    "name": "PCMC to Mumbai Taxi",
    "description": "PCMC to Mumbai Taxi provides convenient and safe taxi services for passengers traveling between Pimpri Chinchwad and Mumbai. Customers benefit from trained drivers, clean vehicles, and door-to-door service. With real-time tracking, easy online booking, and multiple payment options, the service ensures a comfortable, reliable, and affordable travel experience for daily commuters, families, and corporate travelers alike."
  },
  {
    "name": "Pimpri to Mumbai Cab",
    "description": "Pimpri to Mumbai Cab offers a dependable cab service for one-way or round-trip journeys between Pimpri and Mumbai. The service provides a fleet of hatchbacks, sedans, and SUVs with experienced chauffeurs, ensuring smooth travel. Online booking, transparent fares, and 24/7 customer support make it ideal for airport transfers, corporate travel, or leisure trips, providing convenience and comfort for passengers."
  },
  {
    "name": "Chinchwad to Mumbai Cab",
    "description": "Chinchwad to Mumbai Cab delivers reliable intercity transportation with clean, comfortable vehicles and professional drivers. The service is suitable for families, business travelers, and tourists seeking punctual pickups and hassle-free travel. With a focus on safety, transparency, and customer satisfaction, Chinchwad to Mumbai Cab ensures an enjoyable journey along the busy Pune-Mumbai corridor."
  },
  {
    "name": "Pimpri to Mumbai Car Hire",
    "description": "Pimpri to Mumbai Car Hire provides a wide range of vehicles for hire, including hatchbacks, sedans, SUVs, and luxury cars. Customers can choose self-drive or chauffeur-driven options for intercity travel. The service emphasizes comfort, reliability, and timely pickups, catering to families, corporate travelers, and tourists. Online booking, fare transparency, and 24/7 support make this car hire service convenient and trustworthy."
  },
  {
    "name": "Pimpri to Mumbai One Way Taxi",
    "description": "Pimpri to Mumbai One Way Taxi specializes in economical single-trip travel from Pimpri Chinchwad to Mumbai. Passengers can enjoy affordable rates without compromising on comfort or safety. The service includes air-conditioned vehicles, professional drivers, and online booking options. It is ideal for airport transfers, business trips, or casual travel, ensuring timely pickups and smooth rides for one-way journeys."
  },
  {
    "name": "Pimpri to Mumbai Drop Service",
    "description": "Pimpri to Mumbai Drop Service focuses on convenient one-way drop trips to Mumbai, offering reliable and timely transportation. Customers can select from hatchbacks, sedans, SUVs, or luxury vehicles with professional drivers. The service guarantees comfortable seating, air-conditioned interiors, and smooth journeys. Online booking and fare transparency provide a stress-free experience for families, corporate clients, and individual travelers."
  },
  {
    "name": "Pimpri to Mumbai Innova Cab",
    "description": "Pimpri to Mumbai Innova Cab provides spacious Toyota Innova vehicles for intercity travel, perfect for families and groups. The service features professional drivers, air-conditioned comfort, and smooth rides. Online reservations allow easy scheduling, fare transparency, and 24/7 support. This cab option ensures a reliable, safe, and comfortable journey between Pimpri Chinchwad and Mumbai for long or short trips."
  },
  {
    "name": "Pimpri to Mumbai Ertiga Cab",
    "description": "Pimpri to Mumbai Ertiga Cab offers comfortable Maruti Ertiga vehicles for medium-sized groups traveling from Pimpri Chinchwad to Mumbai. With ample seating, air conditioning, and professional drivers, the service ensures safe and smooth travel. Online booking, clear fare details, and 24/7 assistance make it ideal for family trips, group outings, or business travel along the Pune-Mumbai route."
  },
  {
    "name": "Affordable PCMC to Mumbai Taxi",
    "description": "Affordable PCMC to Mumbai Taxi provides budget-friendly options for passengers seeking reliable transportation between Pimpri Chinchwad and Mumbai. The service offers clean vehicles, professional drivers, and transparent pricing without compromising on comfort or safety. Online booking, fare estimates, and 24/7 availability make it suitable for students, families, and frequent travelers looking for dependable yet economical intercity travel."
  },
  {
    "name": "Pimpri to Mumbai Outstation Cab",
    "description": "Pimpri to Mumbai Outstation Cab specializes in long-distance intercity travel with a focus on comfort, safety, and punctuality. The service includes a fleet of hatchbacks, sedans, SUVs, and luxury cars, all maintained for smooth rides. Professional drivers familiar with the route ensure timely pickups and drops. Online booking, fare transparency, and 24/7 customer support make this service ideal for business trips, family outings, or group travel."
  },
  {
    "name": "Pimpri to Mumbai Airport Drop",
    "description": "Pimpri to Mumbai Airport Drop provides dedicated services for passengers heading to Mumbai airports. The service ensures timely pickups, air-conditioned vehicles, and professional drivers. Customers can book online, track rides in real-time, and access 24/7 support. Suitable for both domestic and international flights, this service guarantees a comfortable, reliable, and stress-free journey from Pimpri Chinchwad to the airport."
  },
  {
    "name": "Pimpri to Mumbai Luxury Taxi",
    "description": "Pimpri to Mumbai Luxury Taxi offers premium vehicles such as BMW, Audi, and Mercedes for passengers seeking a high-end travel experience. The service features professional chauffeurs, spacious and elegant interiors, and transparent fare estimates. Online booking and 24/7 customer support make it ideal for VIP travel, business executives, or special occasions, ensuring a comfortable, secure, and luxurious journey from Pimpri Chinchwad to Mumbai."
  },
  {
    "name": "Pimpri to Mumbai Cab Booking Online",
    "description": "Pimpri to Mumbai Cab Booking Online provides a seamless platform to reserve cabs digitally for trips between Pimpri Chinchwad and Mumbai. Customers can choose vehicle types, schedule pickups, and receive instant confirmations. The platform supports multiple payment options, fare transparency, and cancellation or rescheduling features. With real-time tracking, driver details, and 24/7 assistance, passengers enjoy a convenient, safe, and reliable intercity travel experience."
  },
  {
    "name": "PCMC to Mumbai Taxi near Me",
    "description": "PCMC to Mumbai Taxi near Me ensures quick access to nearby taxis for intercity travel between Pimpri Chinchwad and Mumbai. The service provides well-maintained vehicles, professional drivers, and fast booking options. With transparent fares, air-conditioned vehicles, and reliable service, this option is ideal for travelers needing immediate pickup, airport transfers, or short-notice trips."
  }
],
"tableData": [
  ["Pimpri Chinchwad to Mumbai Cab", "PCMC to Mumbai Taxi"],
  ["Pimpri to Mumbai Cab", "Chinchwad to Mumbai Cab"],
  ["Pimpri to Mumbai Car Hire", "Pimpri to Mumbai One Way Taxi"],
  ["Pimpri to Mumbai Drop Service", "Pimpri to Mumbai Innova Cab"],
  ["Pimpri to Mumbai Ertiga Cab", "Affordable PCMC to Mumbai Taxi"],
  ["Pimpri to Mumbai Outstation Cab", "Pimpri to Mumbai Airport Drop"],
  ["Pimpri to Mumbai Luxury Taxi", "Pimpri to Mumbai Cab Booking Online"],
  ["PCMC to Mumbai Taxi near Me", ""]
],


"whychoose": [
  {
    "WhyChooseheading": "Pimpri Chinchwad to Mumbai Cab Service",
    "WhyChoosedescription": "Sai Trupti Cabs Pvt Ltd offers reliable and comfortable cab services from Pimpri‑Chinchwad to Mumbai, tailored for business travel, airport transfers or leisure trips."
  },
  {
    "WhyChooseheading": "Transparent and Competitive Fares",
    "WhyChoosedescription": "We provide clear, competitive one‑way fares from Pimpri Chinchwad to Mumbai — inclusive of tolls and taxes — so there are no hidden surprises."
  },
  {
    "WhyChooseheading": "Wide Range of Vehicle Options",
    "WhyChoosedescription": "Choose from hatchbacks, sedans, SUVs or premium cars to suit your group size, luggage and comfort preferences for the Pimpri‑Chinchwad to Mumbai route."
  },
  {
    "WhyChooseheading": "Professional and Experienced Drivers",
    "WhyChoosedescription": "Our courteous, skilled drivers are familiar with the Pimpri‑Chinchwad to Mumbai route and ensure a safe, smooth and punctual journey."
  },
  {
    "WhyChooseheading": "Flexible Pickup and Drop‑off Locations",
    "WhyChoosedescription": "We offer convenient pickups in Pimpri‑Chinchwad (and surrounding areas) and drop‑offs across Mumbai—including airports, railway stations and city locations."
  },
  {
    "WhyChooseheading": "Clean, Comfortable and Well‑Maintained Cars",
    "WhyChoosedescription": "All our vehicles are regularly serviced, sanitized and prepared for long‑distance travel between Pimpri‑Chinchwad and Mumbai for maximum comfort."
  },
  {
    "WhyChooseheading": "24/7 Booking and Customer Support",
    "WhyChoosedescription": "Our dedicated support team is available around the clock to assist with pickups, route queries or changes on your Pimpri‑Chinchwad to Mumbai cab journey."
  },
  {
    "WhyChooseheading": "Hassle‑Free Online Booking Process",
    "WhyChoosedescription": "Book your cab from Pimpri‑Chinchwad to Mumbai quickly and easily via call, WhatsApp or our website — with instant confirmation and prompt dispatch."
  }
]





















  }

const faqData = [
  {
    question: 'Does Sai Trupti Cabs  offer Pimpri Chinchwad to Mumbai cab services?',
    answer: 'Yes, Sai Trupti Cabs  provides reliable and affordable Pimpri Chinchwad to Mumbai cab services for one way, round trip, and airport transfers.',
  },
  {
    question: 'How can I book a Pimpri Chinchwad to Mumbai cab with Sai Trupti Cabs?',
    answer: 'You can easily book your Pimpri Chinchwad to Mumbai cab through our website, mobile app, or by calling our 24×7 customer support team.',
  },
  {
    question: 'What types of cabs are available from Pimpri Chinchwad to Mumbai?',
    answer: 'We offer hatchbacks, sedans, SUVs, tempo travellers, and luxury cars to suit your travel comfort, group size, and budget.',
  },
  {
    question: 'Are the drivers experienced for the Pimpri Chinchwad to Mumbai route?',
    answer: 'Yes, all our drivers are professional, courteous, and experienced in driving on the Pimpri Chinchwad–Mumbai route, ensuring a safe and pleasant trip.',
  },
  {
    question: 'Can I book a Pimpri Chinchwad to Mumbai airport cab?',
    answer: 'Certainly. We provide dedicated Pimpri Chinchwad to Mumbai Airport transfer services with on-time pickup and drop facilities.',
  },
  {
    question: 'Is the Pimpri Chinchwad to Mumbai cab service available 24×7?',
    answer: 'Yes, Sai Trupti Cabs offers 24×7 cab services from Pimpri Chinchwad to Mumbai to match your travel schedule and convenience.',
  },
  {
    question: 'What are the Pimpri Chinchwad to Mumbai cab fares?',
    answer: 'Our cab fares start from ₹1,600 for hatchbacks, ₹1,900–₹2,600 for sedans, and ₹3,200 onwards for SUVs, depending on vehicle type and travel requirements.',
  },
  {
    question: 'What payment options are available for Pimpri Chinchwad to Mumbai cab bookings?',
    answer: 'We accept UPI, credit/debit cards, bank transfers, and digital wallets for secure and easy payments.',
  },
  {
    question: 'What safety and hygiene measures are maintained for Pimpri Chinchwad to Mumbai cabs?',
    answer: 'All vehicles are sanitized before every ride, and our drivers strictly follow hygiene and safety protocols for a worry-free journey.',
  },
  {
    question: 'Is customer support available during the Pimpri Chinchwad to Mumbai cab journey?',
    answer: 'Yes, our 24×7 customer support team is available to assist you throughout your Pimpri Chinchwad to Mumbai travel.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Akash Jadhav',
    feedback: 'I booked a Pimpri Chinchwad to Mumbai cab with Sai Trupti Cabs. The driver was punctual, and the car was in excellent condition.',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Snehal Patil',
    feedback: 'Sai Trupti Cabs made my Pimpri Chinchwad to Mumbai airport transfer super smooth. Great service and reasonable fare!',
    rating: 5,
  },
];
























































  const Images = [
  { place: "/images/keyword/1.jpg", text: "Pune to Mumbai Cab", link: "Pune-to-Mumbai-Cab" },
  { place: "/images/keyword/2.jpg", text: "Pune to Mumbai Airport Cab", link: "Pune-to-Mumbai-Airport-Cab" },
  { place: "/images/keyword/3.jpg", text: "Pune to Mumbai International Airport Cab", link: "Pune-to-Mumbai-International-Airport-Cab" },
  { place: "/images/keyword/4.jpg", text: "Pune to Mumbai One Way Cab", link: "Pune-to-Mumbai-One-Way-Cab" },
  { place: "/images/keyword/5.jpg", text: "Pune Mumbai Car Hire", link: "Pune-Mumbai-Car-Hire" },
  { place: "/images/keyword/6.jpg", text: "Pune to Mumbai Taxi Fare", link: "Pune-to-Mumbai-Taxi-Fare" },
  { place: "/images/keyword/7.jpg", text: "Pune to Mumbai Online Cab Booking", link: "Pune-to-Mumbai-Online-Cab-Booking" },
  { place: "/images/keyword/8.jpg", text: "Pimpri Chinchwad to Mumbai Cab", link: "Pimpri-Chinchwad-to-Mumbai-Cab" },
  { place: "/images/keyword/9.jpg", text: "Baner to Mumbai Cabs", link: "Baner-to-Mumbai-Cabs" },
  { place: "/images/keyword/10.jpg", text: "Hinjewadi to Mumbai Cab", link: "Hinjewadi-to-Mumbai-Cab" },
  { place: "/images/keyword/11.jpg", text: "Pimple Saudagar to Mumbai Cab Service", link: "Pimple-Saudagar-to-Mumbai-Cab-Service" },
  { place: "/images/keyword/12.jpg", text: "Wakad to Mumbai Cab", link: "Wakad-to-Mumbai-Cab" },
  { place: "/images/keyword/13.jpg", text: "Hadapsar to Mumbai Cab", link: "Hadapsar-to-Mumbai-Cab" },
  { place: "/images/keyword/14.jpg", text: "Kalyani Nagar to Mumbai Taxi", link: "Kalyani-Nagar-to-Mumbai-Taxi" },
  { place: "/images/keyword/15.jpg", text: "Koregaon Park to Mumbai Cab", link: "Koregaon-Park-to-Mumbai-Cab" },
  { place: "/images/keyword/16.jpg", text: "Kothrud to Mumbai Cab", link: "Kothrud-to-Mumbai-Cab" },
  { place: "/images/keyword/17.jpg", text: "Kharadi to Mumbai Cab", link: "Kharadi-to-Mumbai-Cab" },
  { place: "/images/keyword/18.jpg", text: "Shivajinagar to Mumbai Cab", link: "Shivajinagar-to-Mumbai-Cab" },
  { place: "/images/keyword/19.jpg", text: "Pune to Mumbai Ertiga Cab", link: "Pune-to-Mumbai-Ertiga-Cab" },
  { place: "/images/keyword/20.jpg", text: "Pune to Mumbai Innova Crysta Cab", link: "Pune-to-Mumbai-Innova-Crysta-Cab" },
  { place: "/images/keyword/21.jpg", text: "Pune to Mumbai Sedan Cab", link: "Pune-to-Mumbai-Sedan-Cab" },
  { place: "/images/keyword/22.jpg", text: "Kondhwa to Mumbai Cab", link: "Kondhwa-to-Mumbai-Cab" },
  { place: "/images/keyword/23.jpg", text: "Viman Nagar to Mumbai Cabs", link: "Viman-Nagar-to-Mumbai-Cabs" },
  { place: "/images/keyword/24.jpg", text: "Katraj to Mumbai Cab Service", link: "Katraj-to-Mumbai-Cab-Service" },
  { place: "/images/keyword/25.jpg", text: "Pune Station to Mumbai Cabs Service", link: "Pune-Station-to-Mumbai-Cabs-Service" },
];













const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pimpri Chinchwad to Mumbai Cab",
  "image": "https://saitrupticabs.com/assets/images/pimpri-chinchwad-to-mumbai-cab.jpg",
  "description": "Book Pimpri Chinchwad to Mumbai Cab with Sai Trupti Cabs for a comfortable and affordable travel experience. Choose from AC Sedans, SUVs, and Luxury Cars for one-way, round-trip, or airport transfers. Enjoy 24/7 booking support, verified drivers, and on-time service from PCMC to Mumbai.",
  "brand": {
    "@type": "Brand",
    "name": "Sai Trupti Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "15284"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "2399",
    "availability": "https://schema.org/InStock",
    "url": "https://saitrupticabs.com/pimpri-chinchwad-to-mumbai-cab"
  }
};







  return (
    <div>
      <Helmet>
  <title>Pimpri Chinchwad to Mumbai Cab | Safe & Affordable | Sai Trupti Cabs</title>
  <meta 
    name="description" 
    content="Book Pimpri Chinchwad to Mumbai Cab with Sai Trupti Cabs for a comfortable and affordable travel experience. Choose from AC Sedans, SUVs, and Luxury Cars for one-way, round-trip, or airport transfers. Enjoy 24/7 booking support, verified drivers, and on-time service from PCMC to Mumbai." 
  />
  <meta 
    name="keywords" 
    content="Pimpri Chinchwad to Mumbai Cab, PCMC to Mumbai Taxi, Pimpri to Mumbai Cab, Chinchwad to Mumbai Cab, Pimpri to Mumbai Car Hire, Pimpri to Mumbai One Way Taxi, Pimpri to Mumbai Drop Service, Pimpri to Mumbai Innova Cab, Pimpri to Mumbai Ertiga Cab, Affordable PCMC to Mumbai Taxi, Pimpri to Mumbai Outstation Cab, Pimpri to Mumbai Airport Drop, Pimpri to Mumbai Luxury Taxi, Pimpri to Mumbai Cab Booking Online, PCMC to Mumbai Taxi near Me" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>
<section
      className="breadcrumb-section"
      style={{ backgroundImage: "url(/images/background/inner-banner-bg.png)" }}
    >
      <div className="container">
        <div className="banner-content">
          <h1> {cardData.keyword}</h1>
        </div>
      </div>
    </section>



      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/8.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Sai Trupti Cabs</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sai Trupti Cabs </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+918390907004" className="pc-call">+91 8390907004</a>
                      <a href="tel:+919922727744" className="pc-call">+91 9922727744</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/918390907004"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+918390907004" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@saitrupticabs.com" className="pc-email">
                      booking@saitrupticabs.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Sai Trupti Cabs </strong><br />
                      Yashoda splendid Park,
                      Office number D. Wing Dudulgaon Anandi,
                        ruial Sainath Chowk Alandi-412105
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Pimprichichwadtomumbaicab;